var app = {
	header: {
		build: "Sestavení",
		closeButton: "Zavřít",
		copyrightLabel: "Autorská práva",
		helpLabel: "Nápověda",
		legalNoticeLabel: "Právní upozornění",
		logoutButton: "Odhlásit se",
		menuLabel: "Menu",
		module: "Modul",
		myData: "Moje data",
		noUserDataLabel: "Nejsou k dispozici žádná uživatelská data",
		notificationsLabel: "Oznámení",
		privacyPolicyLabel: "Zásady ochrany osobních údajů",
		search: "Hledat",
		searchPlaceholder: "Hledat termín nebo otázku",
		serviceAppLabel: "Aplikace služeb",
		settingsLabel: "Nastavení",
		shopLabel: "Obchod",
		smartFactorySuiteLabel: "Smart-Factory Suite",
		softwareInformation: "Informace o softwaru",
		toMytrumpf: "Do MyTRUMPF",
		toTrumpfCom: "Do trumpf.com",
		userLabel: "Profil",
		userProfileLinkText: "Uživatelský profil",
		version: "Verze"
	}
};
var contentLoadingError = "Obsah nelze načíst";
var dashboard = {
	cancel: {
		button: "Zrušit"
	},
	edit: {
		button: "Upravit"
	},
	reset: {
		button: "Resetovat"
	},
	save: {
		button: "Uložit"
	},
	share: {
		button: "Sdílet"
	}
};
var fileUpload = {
	invalidFileType: "Soubor má nesprávný typ",
	maxFileSize: "Soubor je větší než povolená velikost (max. {{maxSizeInMb}} MB)",
	maxFilesReached: "Byl dosažen maximální počet souborů"
};
var filter = {
	clear: "Resetovat filtry",
	clearAll: "Resetovat všechny filtry"
};
var general = {
	nextButton: "Další",
	prevButton: "Předchozí",
	resetButton: "Resetovat"
};
var locationMap = {
	locationLink: {
		label: "K umístění"
	}
};
var machineDiscontinuation = {
	linkText: "Dozvědět se více"
};
var notifications = {
	button: {
		loadMore: "Načíst více"
	},
	date: {
		lastMonth: "Minulý měsíc",
		lastWeek: "Minulý týden",
		older: "Starší",
		thisMonth: "Tento měsíc",
		thisWeek: "Tento týden",
		today: "Dnes",
		yesterday: "Včera"
	},
	error: {
		general: "V současné době nelze zobrazit oznámení. Zkuste to prosím později.",
		unauthorized: "Pro zobrazení oznámení se prosím přihlaste"
	},
	info: {
		activateSettings: "Pro příjem oznámení je prosím aktivujte v nastavení",
		noNotification: "V současné době nemáte žádné zprávy."
	},
	title: "Oznámení"
};
var results = {
	counter: {
		label: "výsledků"
	}
};
var scrollToTop = {
	label: "Posunout nahoru"
};
var slider = {
	nextButton: {
		label: "Další slide"
	},
	paginationBullet: {
		label: "Slide"
	},
	prevButton: {
		label: "Předchozí slide"
	}
};
var sorting = {
	ascending: "Vzestupně",
	descending: "Sestupně"
};
var userAccount = {
	address: {
		label: "Poštovní adresa"
	},
	email: {
		label: "E-mail"
	},
	language: {
		label: "Jazyk",
		locale: "Lokalita",
		select: "Vybrat jazyk",
		settings: "Nastavení jazyka"
	},
	loggedOut: {
		message: "Nejste přihlášeni"
	},
	login: {
		button: "Přihlásit se"
	},
	name: {
		label: "Jméno"
	},
	phone: {
		label: "Telefon"
	}
};
var widget = {
	filter: {
		machine: {
			filter: "Filtrovat stroje",
			label: "Stroje",
			option: {
				all: "Všechny stroje"
			},
			select: "Vybrat stroj"
		},
		period: {
			label: "Období",
			option: {
				currentMonth: "Tento měsíc",
				currentWeek: "Tento týden",
				lastMonth: "Minulý měsíc",
				lastWeek: "Minulý týden",
				today: "Dnes",
				yesterday: "Včera"
			}
		}
	}
};
var widgetRegistry = {
	allWidgets: {
		label: "Moje widgety"
	},
	noDescriptionAvailable: "Popis není k dispozici.",
	widget: {
		SampleMyMachines: {
			title: "Moje stroje"
		},
		SampleMyServiceCalls: {
			title: "Servisní volání"
		},
		SampleMyTrackingList: {
			title: "Seznam sledování"
		},
		SampleMyUserAccount: {
			title: "Můj profil"
		},
		SampleOperationalStatesChart: {
			title: "Provozní stavy"
		},
		SampleWidgetFilter: {
			title: "Nastavení filtrů"
		},
		SampleWorkloadBalanceChart: {
			title: "Vyvážení pracovní zátěže"
		}
	}
};
var translation = {
	app: app,
	contentLoadingError: contentLoadingError,
	dashboard: dashboard,
	fileUpload: fileUpload,
	filter: filter,
	general: general,
	locationMap: locationMap,
	machineDiscontinuation: machineDiscontinuation,
	notifications: notifications,
	results: results,
	scrollToTop: scrollToTop,
	slider: slider,
	sorting: sorting,
	userAccount: userAccount,
	widget: widget,
	widgetRegistry: widgetRegistry
};

export { app, contentLoadingError, dashboard, translation as default, fileUpload, filter, general, locationMap, machineDiscontinuation, notifications, results, scrollToTop, slider, sorting, userAccount, widget, widgetRegistry };
